import React from "react";
import { ReporteRow } from "../../../../models/ReporteChequeo";
import { calcularTiempoTrabajado } from "../../../../interfaces/formik/IReporteRelojChecador.ts";
import {
  reporteChequeoTableUi as S,
  REPORTE_CHEQUEO_DAY_SUM_LABEL_COLSPAN,
} from "./reporteChequeoTableUi.ts";

const LastRowSummary = ({ records }: { records: ReporteRow[] }) => {
  const [total, setTotal] = React.useState(0);

  React.useEffect(() => {
    setTotal(
      records.reduce((acc, record) => {
        const time = calcularTiempoTrabajado(
          record.checkIn?.assistanceCheck_checkTime!,
          record.checkOut?.assistanceCheck_checkTime
        );
        return acc + Number(time) || 0;
      }, 0)
    );
  }, [records]);

  if (records.length === 0) {
    return null;
  }

  return (
    <tr style={S.grandSumRow}>
      <td
        colSpan={REPORTE_CHEQUEO_DAY_SUM_LABEL_COLSPAN}
        style={{ ...S.grandSumLabel, borderBottomLeftRadius: 16 }}
      >
        Horas totales del periodo
      </td>
      <td style={S.grandSumHours}>{total.toFixed(1)}</td>
      <td style={S.grandSumCellEmpty} />
      <td
        style={{ ...S.grandSumCellEmpty, borderBottomRightRadius: 16 }}
      />
    </tr>
  );
};

export default LastRowSummary;
